import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const conference: ApiFunc<`${typeof API.CONFERENCE}{id}`, 'get'> = data =>
  instance.get(`${API.CONFERENCE}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const conferenceAll: ApiFunc<`${typeof API.CONFERENCE_ALL}`, 'get'> = data =>
  instance.get(API.CONFERENCE_ALL, { params: data })

export const conferenceArticleCreate: ApiFunc<`${typeof API.CONFERENCE_ARTICLE}`, 'post'> = data =>
  instance.post(API.CONFERENCE_ARTICLE, data)

export const conferenceArticle: ApiFunc<`${typeof API.CONFERENCE_ARTICLE_BY_ID}{id}`, 'get'> = data =>
  instance.get(`${API.CONFERENCE_ARTICLE_BY_ID}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const conferenceArticleAll: ApiFunc<`${typeof API.CONFERENCE_ARTICLE_ALL}`, 'get'> = data =>
  instance.get(API.CONFERENCE_ARTICLE_ALL, { params: data })

export const conferenceCategoryAll: ApiFunc<`${typeof API.CONFERENCE_CATEGORY_ALL}`, 'get'> = data =>
  instance.get(API.CONFERENCE_CATEGORY_ALL, { params: data })
